import { render, staticRenderFns } from "./CadastroSimples.vue?vue&type=template&id=2babab06&"
import script from "./CadastroSimples.vue?vue&type=script&lang=js&"
export * from "./CadastroSimples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports